
<p>Please select the mobile number you would like to receive your verification code.</p>
<div class="form-group">
<select class="form-control" (change)="numberChanged($event)">
  <option *ngFor="let item of mobileNumbers" value="{{item.value}}">{{item.label}}: *******{{item.value.substr(item.value.length-3,3)}}</option>
</select>
</div>

<div  class="text-center margin-top-base padding-top-base">
  <button class="btn btn-primary  margin-right-base" [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService.TextButtonColor.value}"
  (click)="onBack()"> &nbsp; BACK &nbsp;</button>
  <button class="btn btn-primary" [disabled]="mobileNumbers.length == 0" [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService.TextButtonColor.value}"
  (click)="onContinue()">SEND CODE</button>
</div>
